module.exports = __webpack_public_path__ + "static/media/win_1.8cf5e86a.mp3";